<template>
  <b-card>
    <b-container fluid class="p-4 bg-dark">
      <div align="center"> <a href="#/index"> <img   src="images/logout.png"  alt=""></a></div>
    </b-container>
<!--    <b-container fluid class="p-4 bg-dark">-->
<!--      <b-row>-->
<!--        <b-col lg="2"></b-col>-->
<!--        <b-col lg="10">-->
<!--          <table id="Table_01"  border="0" cellpadding="0" cellspacing="0" align="center">-->
<!--            <tr>-->
<!--              <td >-->
<!--                <a href="login"> <img   src="img/65/thank_2565.jpg" width="100%" alt=""></a>-->
<!--              </td>-->
<!--            </tr>-->
<!--          </table>-->
<!--        </b-col>-->
<!--        <b-col lg="2"></b-col>-->
<!--      </b-row>-->
<!--    </b-container>-->
  </b-card>

</template>

<script>


export default {
  components: {},
  name: "CreateThank",
  data() {
    return {};
  },
  methods: {},
  mounted() {},
  created() {
    if (this.$store.state.user !=null) {
      this.$store.dispatch("setToken", null);
      this.$store.dispatch("setUser", null);
      // this.$store.dispatch("setStatus", null);
      // this.$router.push("/Thank");
      // this.$router.push("/index");
     // this.$router.push("/login");
    }else{
      // this.$router.push("/Thank");
      // this.$router.push("/index");
      //this.$router.push("/login");
    }
  }
};
</script>
<style>
</style>
